import SiteSearchResultsTable from './SiteSearchResultsTable';

export default SiteSearchResultsTable;
